// When making changes to these interfaces, please update the documentation here: https://aka.ms/transcriptionwordwebfileformat

// In DocumentStorageTranscriptionManager, StoredTranscriptionDescriptor is an object that contains an ITranscription,
// so any changes to ITranscription should be documented in the URL above.
export type StoredTranscriptionDescriptor = any;

export enum TranscriptionStorageType {
    DocumentStorage = 'DocumentStorage'
}

export interface IStoredTranscription {
    storageType: TranscriptionStorageType,
    descriptor: StoredTranscriptionDescriptor
}